import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { Modal, Form, FormGroup } from 'react-bootstrap';
import * as umoModifications from '../../constants/umoModifications';
import Button from '../ui/Button';
import { createUMOModURL } from '../../utils/umoUtils';
import { downloadFile } from '../../utils/uiUtils';

/* eslint-disable jsx-a11y/label-has-for */
class ResizeDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isValid: false,
      error: null,
      isSuccess: false,
      type: '',
      width: 800,
      dpi: '',
      quality: 85,
      embedMeta: true,
      createDeriv: false,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  onFormSubmit(e) {
    e.preventDefault();

    // const umoDataList = selectedUMOIDs.map(umoID => ({ UMO_ID: umoID }));
    // Should not use workspace id when using umo ids - it will cause the umo ids to be ignored
    let umos;
    if (this.props.isSelectAll || !this.props.umoList) {
      umos = this.props.umoList && this.props.umoList.length > 0 ?
      [{ SEARCH: `IN_CATEGORY:"${this.props.workspaceID}"` },
          { EXCLUDE_UMO_ID: this.props.umoList }]
        : [{ SEARCH: `IN_CATEGORY:"${this.props.workspaceID}"` }];
    } else {
      umos = [{ UMO_ID: this.props.umoList }];
    }

    const modData = [{ RESIZE_WIDTH: this.state.width },
      { IMAGE_QUALITY: this.state.quality },
      { IMAGE_DPI: this.state.dpi },
      { IMAGE_FORMAT: this.state.type },
      { CREATE_DERIV: this.state.createDeriv ? 'TRUE' : 'FALSE' },
      ...umos,
    ];

    downloadFile(createUMOModURL(umoModifications.UMO_MODIFY_TYPE_RESIZE, modData));
    this.props.addMessage('umoModifyDialog.inProgressMessage');
    this.props.hideUMOModifyDialog();
  }

  updateField(newData) {
    const fieldsState = {
      type: this.state.type,
      width: _.toSafeInteger(this.state.width),
      dpi: this.state.dpi,
      quality: this.state.quality,
      embedMeta: this.state.embedMeta,
      ...newData,
    };

    fieldsState.isValid = fieldsState.width > 200 && fieldsState.dpi !== '' && fieldsState.type !== '';

    this.setState(fieldsState);
  }

  render() {
    const { intl } = this.props;
    return (
      <div className="workspace-dialog__form">
        <div className="workspace-dialog__form-header">
          {intl.formatMessage({ id: 'workspaceResizeDialog.mainTitle' })}
          <div className="workspace-dialog__form-header-sub">
            {intl.formatMessage({ id: 'workspaceResizeDialog.optionsTitle' })}
          </div>
        </div>
        <Form onSubmit={this.onFormSubmit}>
          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceResizeDialog.optionsType' })}
            </label>
            <select
              name="TYPE"
              className="form-control"
              value={this.state.type}
              onChange={(e) => { this.updateField({ type: e.target.value }); }}
            >
              {_.map(umoModifications.IMAGE_TYPES,
                    type => <option key={type} value={type}>{type}</option>)}
            </select>
          </FormGroup>
          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceResizeDialog.optionsWidth' })}
            </label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => { this.updateField({ width: e.target.value }); }}
              value={this.state.width}
            />
          </FormGroup>
          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceResizeDialog.optionsDPI' })}
            </label>
            <select
              className="form-control"
              name="DPI"
              value={this.state.dpi}
              onChange={(e) => { this.updateField({ dpi: e.target.value }); }}
            >
              {_.map(umoModifications.DPI_TYPES,
                    type => <option key={type.value} value={type.value}>{type.name}</option>)}
            </select>
          </FormGroup>

          <FormGroup>
            <label className="control-label">
              {intl.formatMessage({ id: 'workspaceResizeDialog.optionsQuality' })}
            </label>
            <select
              className="form-control"
              name="quality"
              value={this.state.quality}
              onChange={(e) => { this.updateField({ quality: e.target.value }); }}
            >
              {_.range(1, 100 + 1).map(
                    value => <option key={value} value={value}>{value}</option>)}
            </select>
          </FormGroup>
          <Modal.Footer>
            <Button onClick={this.props.onCloseClick}>
              {intl.formatMessage({ id: 'umoModifyDialog.buttonCancel' })}
            </Button>

            <Button primary type="submit">
              {intl.formatMessage({ id: 'umoModifyDialog.buttonApply' })}
            </Button>
          </Modal.Footer>
        </Form>
      </div>
    );
  }
}

ResizeDialog.propTypes = {
  hideUMOModifyDialog: PropTypes.func,
  umoList: PropTypes.instanceOf(Array),
  workspaceID: PropTypes.string,
  addMessage: PropTypes.func,
  onCloseClick: PropTypes.func,
  isSelectAll: PropTypes.bool,
};

export default injectIntl(ResizeDialog);



// WEBPACK FOOTER //
// ./src/js/components/UMOModifyDialog/ResizeDialog.jsx